import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'code',
        headerName: 'Mã Ticket',
        editable: false,
        sortable: true,
        minWidth: 150,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'name',
        headerName: 'Tên',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
        sortingOrder: ['asc', 'desc'],
    },
    {
        field: 'user',
        headerName: 'Người phụ trách',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row?.assignee?.fullname}>
                <EntityDetailButton
                    text={params.row?.assignee?.fullname}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.assignee?.id}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'lastExecutedAt',
        headerName: 'Ngày chạy gần nhất',
        editable: false,
        sortable: true,
        minWidth: 150,
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
        sortingOrder: ['asc', 'desc'],
    },
    {
        field: 'nextExecutionAt',
        headerName: 'Ngày chạy kế tiếp',
        editable: false,
        sortable: true,
        minWidth: 150,
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
        sortingOrder: ['asc', 'desc'],
    },
    {
        field: 'executionCount',
        headerName: 'Số lần đã chạy',
        editable: false,
        sortable: true,
        minWidth: 150,
        renderCell: params => <HoverCopyCell value={params.value} />,
        sortingOrder: ['asc', 'desc'],
    },
];
